module.exports = __webpack_public_path__ + "img/cloudfun.2e85cdc5.svg";